var _ellipse, _circle, _circle2, _path, _path2, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMajorHazardMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 65,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9628,
    cy: 47.1425,
    rx: 5.621,
    ry: 5.99313,
    fill: "#FF1B17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 47.9629,
    cy: 47.1436,
    r: 27.3242,
    fill: "#FF1B17",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 47.9629,
    cy: 47.1431,
    r: 39.271,
    fill: "#FF1B17",
    fillOpacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1997 77.8204C48.1997 77.8204 65.0972 56.0736 65.0972 46.6242C65.0972 37.1748 57.5331 29.5166 48.1997 29.5166C38.8663 29.5166 31.3022 37.1748 31.3022 46.6242C31.3022 56.0736 48.1997 77.8204 48.1997 77.8204Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1997 77.8204C48.1997 77.8204 65.0972 56.0736 65.0972 46.6242C65.0972 37.1748 57.5331 29.5166 48.1997 29.5166C38.8663 29.5166 31.3022 37.1748 31.3022 46.6242C31.3022 56.0736 48.1997 77.8204 48.1997 77.8204Z",
    fill: "#151515",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1997,
    cy: 46.1704,
    rx: 7.5,
    ry: 7.59327,
    fill: "#FFF308"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorHazardMarker);
export default __webpack_public_path__ + "static/media/major-hazard-marker.fe5d3acb488d25b300e05b0f69706641.svg";
export { ForwardRef as ReactComponent };